import { Button, Dialog, Modal, ModalRef } from 'alurkerja-ui';
import { useRef } from 'react';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { CustomFieldService } from '@/api/customField';
import { FaTrash } from 'react-icons/fa';

type DeleteCustomFieldProps = {
  id: string;
  onSuccess: () => void;
};

export const DeleteCustomField: React.FC<DeleteCustomFieldProps> = ({
  id,
  onSuccess,
}) => {
  const ref = useRef<ModalRef>(null);
  const { mutate: deleteMutate, isPending: isDeleteLoading } =
    CustomFieldService.useDelete();

  const deleteAction = (id: string) => {
    deleteMutate(id, {
      onSuccess: () => {
        Dialog.success({
          title: 'Success',
          description: 'Custom field has been deleted',
          callback: () => {
            onSuccess();
            ref.current?.closeModal();
          },
        });
      },
      onError: () => {
        Dialog.error({
          title: 'Error',
          description: 'Failed to delete custom field',
        });
      },
    });
  };

  return (
    <Modal
      ref={ref}
      triggerButton={
        <Button className="bg-red-600">
          <FaTrash />
        </Button>
      }
      title="Delete Custom Field"
    >
      {({ closeModal }) => {
        return (
          <div className="flex flex-col gap-4 p-4">
            <p className="text-gray-500">
              Are you sure you want to delete this custom field? This action
              cannot be undone.
            </p>

            <div className="flex flex-row gap-2">
              <OutlineButton onClick={closeModal}>Cancel</OutlineButton>
              <Button
                type="button"
                color="red"
                onClick={() => deleteAction(id)}
                loading={isDeleteLoading}
              >
                Delete
              </Button>
              <Button type="button" color="blue">
                Archive
              </Button>
            </div>
          </div>
        );
      }}
    </Modal>
  );
};
